import { render } from "./FileField.vue?vue&type=template&id=20599e2e"
import script from "./FileField.vue?vue&type=script&lang=js"
export * from "./FileField.vue?vue&type=script&lang=js"

import exportComponent from "/home/tobias/Desktop/screenads/nova-custom2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"FileField.vue"]])

export default __exports__